import { render, staticRenderFns } from "./ComprasEmDinheiro.vue?vue&type=template&id=6c642c68&scoped=true"
import script from "./ComprasEmDinheiro.vue?vue&type=script&lang=js"
export * from "./ComprasEmDinheiro.vue?vue&type=script&lang=js"
import style0 from "./ComprasEmDinheiro.vue?vue&type=style&index=0&id=6c642c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c642c68",
  null
  
)

export default component.exports